import React, { useCallback, useState } from 'react';

export const Calendly = React.memo(({ children }) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();

      // Load the script dynamically only on the first click
      if (!scriptLoaded && !window.Calendly) {
        const link = document.createElement('link');
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.type = 'text/javascript';
        script.async = true;
        script.onload = () => {
          setScriptLoaded(true);
          if (window.Calendly) {
            window.Calendly.initPopupWidget({
              url: 'https://calendly.com/webcrumbs/chill-talk-webdev',
            });
          }
        };
        document.body.appendChild(script);
      } else if (window.Calendly) {
        // Script already loaded, initialize the widget
        window.Calendly.initPopupWidget({
          url: 'https://calendly.com/webcrumbs/chill-talk-webdev',
        });
      }
    },
    [scriptLoaded]
  );

  return (
    <div className="cursor-pointer" onClick={handleClick}>
      {children}
    </div>
  );
});
